/**
 * BrandMark — Premier Modulations full logo lockup (mark + wordmark + tagline).
 * Uses the trimmed transparent PNG served from /public for clean rendering on
 * any background.
 */
const LOGO_URL = "/premier-modulations-logo.png";

export default function BrandMark({ className = "h-16 w-auto" }) {
  return (
    <img
      src={LOGO_URL}
      alt="Premier Modulations"
      className={className}
      loading="eager"
      decoding="async"
    />
  );
}
